import './assets/styles/index.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { SnackbarProvider } from 'notistack'

import { router } from './router'
import { store } from './store'

const queryClient = new QueryClient()
import * as Sentry from '@sentry/react'

Sentry.init({
    dsn: 'https://8f776a3ae8058315b0e6d7d7d31059d0@o1354288.ingest.us.sentry.io/4508167633436672',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/trips51-tripbook-eu-tll752sjda-ew\.a\.run\.app/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: import.meta.env.VITE_ENV_NAME === 'prod'
})


ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <React.StrictMode>
                <React.Suspense>
                    {/* Mounting it is what wires up notistack's standalone
                        enqueueSnackbar/closeSnackbar; without it they're undefined. */}
                    <SnackbarProvider>
                        <RouterProvider router={router} />
                    </SnackbarProvider>
                </React.Suspense>
            </React.StrictMode>
        </Provider>
    </QueryClientProvider>
)
